export default "__VITE_PUBLIC_ASSET__fd0d6a80__"